import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1201Model } from '../kymw1201.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 企画回別商品一覧表出力
 * @export OutputPublishPlanGoodsCategoryListInfo
 * @class OutputPublishPlanGoodsCategoryListInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputPublishPlanGoodsCategoryListInfo extends PlessJsonResponderSub<any> {
  private model: KYMW1201Model;

  private vo = {
    OrderCode: '',
    MediumType: '',
    BuyerCode: '',
    SupplierCode: ''
  }

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof OutputBundleMixMatchListService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputPublishPlanGoodsCategoryListInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      search: {
        CatalogInfo: {
          condition: {
            OrderCode: this.vo.OrderCode,
            MediumType: this.vo.MediumType,
            BuyerCode: this.vo.BuyerCode,
            SupplierCode: this.vo.SupplierCode
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputPublishPlanGoodsCategoryListInfo
   */
  execute(model: KYMW1201Model, vo: any, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputPublishPlanGoodsCategoryListInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputPublishPlanGoodsCategoryListInfo
   */
  success(data: any) {
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
